import {  useEffect } from 'react';
import { Link, Form, useActionData, json, useSearchParams, useNavigate } from "react-router-dom";

import {useContext } from "react";

import MenuContext from '../store/MenuContext';
import HeaderClasses from '../components/AppHeader/AppHeader.module.css';
import RegisterClasses from '../components/Register/Register.module.css';


import { forgotUsername } from '../utils/api';

function ForgotUsername() {
		const menuTheme = useContext(MenuContext);

		const actionData=useActionData();
		const [searchParams] = useSearchParams();
		const resend=searchParams.get("resend");
		const navigate=useNavigate(); 
		useEffect(() => {
			console.log(actionData);
			if (actionData?.errors) {
				if (actionData.errors==='Activation code resent.') {
				  navigate(`/activateAccount`);
				} 
			  }
		}, [actionData, navigate]);
    return (
		<div className={RegisterClasses.testInfo}>
    		  <div className={RegisterClasses.testInfoContent}>
				<Form method='post'>
					<div className={RegisterClasses['form-control']}>
						{resend && <h1>Resend Activation Code</h1>}
						{!resend && <h1>Forgot Username</h1>}
						{!actionData?.message &&
						<p>Please fill out the information below and we will send you a link to reset your user ID.</p>}
						<p>Check the email address you provided at sign up.</p>
						{actionData?.errors && <div className={HeaderClasses.error}>{actionData.errors}</div>}
						{!actionData?.message && <div>
						<label>First Name:</label> 
						<input name="firstname" type="text" required/>*<br/>
						<label>Last Name:</label>
						<input name="lastname" type="text" required />*
						<label>Date of Birth:</label>
						<input name="dob" type="Date" required />*
						<label>Email address:</label>
						<input name="email" type="text" required />*
						<nav className={HeaderClasses.headerNav}>
							<div className={RegisterClasses.buttonArea}>  
				            	{!resend &&<button className={HeaderClasses.navItem}>Retrieve Username</button>}
								{resend &&<button className={HeaderClasses.navItem}>Resend Activation Code</button>}
							</div>
						</nav>
						<div className={HeaderClasses.buttonArea}>  
				  			<div className={HeaderClasses.navAreaWhite}>
				  				<Link className={HeaderClasses.navAreaText} to='../ForgotPassword'>Forgot Password</Link>						
							</div>
						</div>
						</div>}
						{actionData?.message &&
						<div className={HeaderClasses.buttonArea}>  
				  			<div className={HeaderClasses.navAreaWhite}>
				  				<Link className={HeaderClasses.navAreaText} to='../Login'>Login</Link>						
							</div>
						</div>}
					</div>
				</Form>
			</div>
		</div>
  );
}

export default ForgotUsername;

export async function action({ request, params }) {
  const data = await request.formData();

  const resUsernameData = {
	firstname: data.get('firstname'),
	lastname: data.get('lastname'),
	dob: data.get('dob'),
	email: data.get('email')
  };
  const response = await forgotUsername(resUsernameData);
		var messages = {};
  		if (response.status===500) {
			throw json(
			  { message: 'Could not retrieve username.' },
			  {
				status: 500,
			  }
			);
		  }
		if (response.status===400) {
			messages.errors="Invalid data";
		}
	console.log(response.status);		
		if (response.ok) {
			if (response.status ===201) {
					messages.message="Username emailed."
			}else{ if(response.status === 200) {
				messages.errors='Activation code resent.'
				}else{
				messages.errors='Could not retrieve username.'
				}
			}
		}
		console.log(messages);
  return messages;
}